import { SerializedError, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { getApiErrorMessage } from "utils/apiErrorMessage";

import {
  LoginRequest,
  LoginResponse,
  RegisterResponse,
  newUserRequest,
} from "js/components/types";

import { createUser, logIn } from "../../../api/accounts";
import { AppDispatch } from "../../store";
import { loadAdvisorData } from "../user/userActions";

export const userLogin = createAsyncThunk<
  LoginResponse,
  LoginRequest,
  { rejectValue: string | SerializedError; dispatch: AppDispatch }
>("auth/login", async ({ email, password }, { rejectWithValue, dispatch }) => {
  try {
    const { data } = await logIn({ email: email, password: password });
    Cookies.set("userToken", data.token, { expires: 1 });

    dispatch(loadAdvisorData(data.token));

    return data;
  } catch (error: unknown) {
    // `data.message` puede ser el diccionario del serializer
    // (`{ email: ["Enter a valid email address."] }`): si se propaga tal cual,
    // `toast.error(error)` de Login.tsx lo renderiza como hijo de React y
    // tumba la app. Aqui se garantiza que el store guarda SIEMPRE un string.
    // (Ademas el acceso directo a `error.response.data.message` lanzaba un
    // TypeError cuando el 502 venia con el cuerpo vacio.)
    return rejectWithValue(
      getApiErrorMessage(
        error,
        "No pudimos iniciar sesión. Inténtalo de nuevo.",
      ),
    );
  }
});

export const registerUser = createAsyncThunk<
  RegisterResponse,
  newUserRequest,
  { rejectValue: string | SerializedError; dispatch: AppDispatch }
>(
  "auth/register",
  async (
    { account, account_data, referral_code },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const registerUserResponse = await createUser({
        account: account,
        account_data: account_data,
        referral_code: referral_code,
      });
      Cookies.set("userToken", registerUserResponse.data.Token, { expires: 2 });
      dispatch(loadAdvisorData());
      return registerUserResponse.data;
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = {
          ...error.response.data,
        };
        // Pass the restructured error data to rejectWithValue
        return rejectWithValue({
          message: "Sign up failed", // or any custom error message
          data: errorData,
        });
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);
